import HeroCarousel from "@/pages/home/components/HeroCarousel";
import FeaturedWorks from "@/pages/home/components/FeaturedWorks";
import ReviewsSection from "@/pages/home/components/ReviewsSection";
import NewsSection from "@/pages/home/components/NewsSection";
import AboutStrip from "@/pages/home/components/AboutStrip";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "疯狂的欲望官网-最新电影电视剧资讯与影评",
    "疯狂的欲望为您提供最新电影和电视剧资讯，包含剧情介绍、演员阵容和影评分析，让您掌握影视动态，畅享高品质观影体验。",
  );

  return (
    <div className="w-full">
      <HeroCarousel />

      <FeaturedWorks
        type="movie"
        eyebrow="Now Showing"
        title="电影精选推荐"
        subtitle="正在热映与即将上映的院线佳作，剧情、阵容与口碑一次看全。"
      />

      <FeaturedWorks
        type="series"
        eyebrow="On Air"
        title="电视剧精选推荐"
        subtitle="热播剧集与高分新剧，追剧之前先来这里做足功课。"
      />

      <ReviewsSection />

      <NewsSection />

      <AboutStrip />
    </div>
  );
}